import {getMapControlsWidth} from '@map/controls/ControlsDrawer';
import {getSidebarWidth} from '@map/sidebars';

/** Returns padding for the map viewport that accounts for controls and sidebar width */
export default function getMapPaddingWithSidebar(
    controlsExpanded = true,
    sidebarWidth = getSidebarWidth()
) {
    // Padding must account for the maximum width of the controls as well as sidebar
    const controlsWidth = getMapControlsWidth(controlsExpanded);
    return {
        left: sidebarWidth + controlsWidth + 10,
        top: 150,
        right: 150,
        bottom: 150,
    };
}
